module.exports = __webpack_public_path__ + "img/lp_whitelist.37a1947a.png";